import { queryOptions, useQuery } from '@tanstack/react-query';

import { giftCardsApi } from '../api/gift-cards-api';

import { giftCardKeys } from './gift-card-keys';

export function giftCardQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: giftCardKeys.detail(storeId, id),
    queryFn: () => giftCardsApi.get(storeId, id),
  });
}

export function useGiftCard(storeId: string, id: string) {
  return useQuery(giftCardQueryOptions(storeId, id));
}
